import { render, staticRenderFns } from "./card-video.vue?vue&type=template&id=5b52f272&scoped=true&"
import script from "./card-video.vue?vue&type=script&lang=js&"
export * from "./card-video.vue?vue&type=script&lang=js&"
import style0 from "./card-video.vue?vue&type=style&index=0&id=5b52f272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52f272",
  null
  
)

export default component.exports